<template>
  <div class="gradient-bg min-h-screen flex flex-col items-center justify-center p-4 relative">
    <!-- 主容器 -->
    <div class="flex flex-col items-center max-w-[500px]">
      <!-- Logo -->
      <div class="text-center mb-[20px] logo-animation">
        <img src="/new-logo.png" alt="Medisyn Logo" class="logo-img"/>
      </div>

      <!-- 登录卡片 -->
      <div
          class="w-[380px] bg-white shadow-2xl rounded-2xl card-animation relative"
          :class="{ 'card-error': showCardError }"
          ref="loginCard"
      >
        <!-- 错误提示 -->
        <div v-show="showError" class="error-message-container">
          <div
              class="bg-red-50 border-l-4 border-red-500 rounded-md shadow-lg error-message-animation"
          >
            <div class="flex items-center p-3">
              <div class="flex-shrink-0">
                <!-- 感叹号图标 -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-red-500">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <div class="ml-3">
                <span class="text-sm font-medium text-red-800">账号或密码错误，请重试</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 卡片头部 -->
        <div class="text-center pt-6 pb-4 px-8">
          <h1 class="text-2xl font-bold text-gray-900 mb-2">欢迎回来！</h1>
          <p class="text-gray-500 text-sm">岚医全域医疗智能体</p>
        </div>

        <!-- 卡片内容 -->
        <div class="px-8 pb-6">
          <form @submit.prevent="handleSubmit" class="w-full space-y-4">
            <!-- 账号输入框 -->
            <div class="space-y-2">
              <label for="account" class="text-sm font-medium text-gray-700 block">账号</label>
              <input
                  id="account"
                  v-model="account"
                  type="text"
                  placeholder="请输入您的账号"
                  class="input-field"
              />
            </div>

            <!-- 密码输入框 -->
            <div class="space-y-2">
              <label for="password" class="text-sm font-medium text-gray-700 block">密码</label>
              <div class="relative">
                <input
                    id="password"
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="请输入密码"
                    class="input-field pr-10"
                />
                <button type="button" @click="togglePassword" class="password-toggle">
                  <!-- 眼睛图标 - 显示密码时显示带斜线的眼睛 -->
                  <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                  <!-- 眼睛图标 - 隐藏密码时显示普通眼睛 -->
                  <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
              </div>
            </div>

            <!-- 验证码输入框 -->
            <div class="space-y-2">
              <label for="captcha" class="text-sm font-medium text-gray-700 block">验证码</label>

              <div class="flex items-center space-x-2">
                <input id="captcha" v-model="captcha" type="text" placeholder="请输入验证码" class="captcha-input"/>
                <img
                    :src="captchaImg"
                    alt="验证码"
                    @click="getCaptcha"
                    style="cursor:pointer;"
                    title="点击刷新验证码"
                    class="captcha-img"
                />
              </div>
            </div>

            <!-- 记住我和忘记密码 -->
            <div class="flex items-center justify-between pt-1">
              <div class="flex items-center space-x-2">
                <input
                    id="remember"
                    v-model="passwordChecked"
                    type="checkbox"
                    class="checkbox-field"
                />
                <label for="remember" class="text-sm text-gray-600 cursor-pointer">记住我</label>
              </div>
              <router-link :to="{ name: 'ForgotPassword' }" class="link-text" @click.native.prevent="$router.push({ name: 'ForgotPassword' })" >忘记密码？</router-link>
            </div>

            <!-- 登录按钮（保留单一按钮） -->
            <button type="submit" class="btn-primary">登录</button>
          </form>
        </div>
      </div>
    </div>

    <!-- 版权声明 -->
    <div class="text-center mt-8">
      <p class="text-white/60 text-xs">© 2024 琼海智医科技有限公司 版权所有</p>
      <p class="text-white/50 text-xs mt-1">岚医全域医疗智能体 · Medisyn Ubimed Agent</p>
    </div>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import {loginNew} from "@/services/newpost";

export default {
  computed: {},
  mounted() {
    // 初始动画完成后移除动画属性
    const cardElement = this.$refs.loginCard;
    if (cardElement) {
      cardElement.addEventListener("animationend", function () {
        this.style.animation = "none";
      });
    }

    this.getCaptcha();
    this.initTenantId();
  },
  created() {
    //1记住密码  0不记住密码
    if (localStorage.getItem("passwordChecked") === '1') {
      this.passwordChecked = true;
      // 账号回显
      var loginForm_qhzy = JSON.parse(localStorage.getItem("loginForm_qhzy"));
      // console.log(loginForm_qhzy);
      if (loginForm_qhzy !== null) {
        this.account = loginForm_qhzy.account;
        this.password = loginForm_qhzy.password;
        console.log("--------------------------------");
        console.log(this.account);
        console.log(this.password);
        console.log("--------------------------------");
      }
    } else {
      this.passwordChecked = false;
    }
  },
  data() {
    return {
      captchaImg: "",//验证码图片base64
      captcha: "",//验证码
      checkKey: "",//验证码key
      showPassword: false,
      showError: false,
      rememberMe: false,
      showCardError: false,

      flag: false,
      fullscreenLoading: false,
      account: "", //用户名或手机号
      password: "", //密码
      passwordChecked: false,
      codeBtnTitle: "验证码",
      disabled: false,
      loginStyle: ["账号登录", "手机号登录"],
      isActive: 0,
      tenantId: "" // 租户ID
    };
  },
  watch: {},
  methods: {
    ...mapActions(["getUserInfoAction"]),

    /* 切换显示隐藏密码 */
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    getCaptcha() {
      this.checkKey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      fetch(this.$urlbase + '/sys/randomImage/' + this.checkKey)
          .then(res => res.json())
          .then(data => {
            if (data.success && data.result) {
              this.captchaImg = data.result;
            }
          });
    },


    /* 登录（切换到 /sys/login） */
    async handleSubmit() {
      const password = this.password;
      const account = this.account;
      const captcha = this.captcha;
      const checkKey = this.checkKey;
      if (
          String(account).trim() === "" ||
          String(password).trim() === "" ||
          String(captcha).trim() === "" ||
          String(checkKey).trim() === ""
      ) {
        this.errorMsg();
        return;
      }
      // 记住密码监听
      if (this.passwordChecked) {
        localStorage.setItem("passwordChecked", '1');
        var loginForm_qhzy = {account, password};
        localStorage.setItem("loginForm_qhzy", JSON.stringify(loginForm_qhzy));
      } else {
        localStorage.setItem("passwordChecked", '0');
        localStorage.removeItem("loginForm_qhzy");
      }

      // 调用 /sys/login（使用现有 loginNew 服务方法）
      let result = await loginNew({
        username: account,
        password,
        captcha,
        checkKey,
        tenantId: this.tenantId
      });

      if (result.code === 200) {
        let token = result.result.token;
        let loginTenantId = result.result.loginTenantId;
        let user = result.result.userInfo;
        let depart = result.result.departs ? result.result.departs[0] : null;
        let username = result.result.userInfo?.username;
        let realname = result.result.userInfo?.realname;
        let userId = result.result.userInfo?.id;

        // 存储本地（同时设置 storeToken 以兼容路由守卫）
        localStorage.setItem("token", token);
        localStorage.setItem("storeToken", token);
        if (loginTenantId) localStorage.setItem("loginTenantId", loginTenantId);
        if (user) localStorage.setItem("user", JSON.stringify(user));
        if (depart) localStorage.setItem("depart", JSON.stringify(depart));
        if (username) localStorage.setItem("username", username);
        if (realname) localStorage.setItem("realname", realname);
        if (userId) localStorage.setItem("userId", userId);

        this.getUserInfoAction().then(res => {
          if (res.code === 200) {
            this.$router.push({name: "ConsultationControl"}).catch(() => {
            });
            this.$message.success("登录成功");
          } else {
            this.getCaptcha();
            this.errorMsg();
          }
        });
      } else {
        this.getCaptcha();
        this.errorMsg();
      }
    },

    /* 登录错误提醒动画 */
    errorMsg() {
      // 显示错误提示
      //this.showError = true;

      // 触发卡片晃动动画
      this.showCardError = false;
      this.$nextTick(() => {
        this.showCardError = true;
      });

      // 动画结束后移除错误状态
      setTimeout(() => {
        this.showCardError = false;
      }, 600);

      // 5秒后自动隐藏错误提示
      setTimeout(() => {
        this.showError = false;
      }, 5000);
    },

    /* 获取租户ID */
    async initTenantId() {
      try {
        const currentUrl = window.location.href;
        const response = await fetch(currentUrl, { method: "GET" });
        this.tenantId = response.headers.get("X-Tenant-Id") || "";
        console.log("获取到的 TenantId：", this.tenantId);
      } catch (error) {
        console.error("获取 TenantId 失败：", error);
        this.tenantId = "1"; // 兜底值
      }
    }
  }
};
</script>

<style src="@/assets/style/pages/login.css"></style>
